import { TZDateMini } from '@date-fns/tz';
import { addMonths, setHours } from 'date-fns';
import { useMemo } from 'react';
import type { DirectFcfsCapacityPool } from 'src/apis/direct-fcfs/types';
import { useNow } from 'src/hooks/use-now';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { getCapacityOverviewPageParamsSchema } from 'src/pages/transport/network-points/details/capacity-overview-fcfs/schema';
import { timeZone } from 'src/utils/date-time-format';

export function useCapacityOverviewPageParams(
  capacityPools: DirectFcfsCapacityPool[]
) {
  const now = useNow();

  const { startDefault, endDefault, capacityPoolId } = useMemo(() => {
    const zonedNow = new TZDateMini(now, timeZone);

    const startDefault = setHours(zonedNow, 0).toISOString();
    const endDefault = setHours(addMonths(zonedNow, 1), 6).toISOString();
    return {
      startDefault,
      endDefault,
      capacityPoolId: capacityPools.at(0)?.id ?? null,
    };
  }, [now, capacityPools]);

  return usePageParamsFromSchema(
    getCapacityOverviewPageParamsSchema({
      startDefault,
      endDefault,
      capacityPoolIdDefault: capacityPoolId,
    }),
    {
      filters: {
        runtimeIntersectionFilterStart: { label: 'Runtime' },
        runtimeIntersectionFilterEnd: { label: 'Runtime' },
        capacityPoolId: { label: 'Capacity Pool' },
      },
    }
  );
}

export type CapacityOverviewPageParams = ReturnType<
  typeof useCapacityOverviewPageParams
>;
